import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { TestimonialsInitial } from './components/TestimonialsInitial';
import { PainPoints } from './components/PainPoints';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CostTable } from './components/CostTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '951980684229426');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=951980684229426&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-gold-500/30" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <TrustBar data-id="element-3" />
        <TestimonialsInitial data-id="element-4" />
        <PainPoints data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonusSection data-id="element-7" />

        {/* Pricing Block */}
        <div id="pricing" className="bg-navy-900/50 py-12 border-y border-navy-800" data-id="element-8">
          <CountdownTimer data-id="element-9" />
          <PricingSection data-id="element-10" />
        </div>

        <ComparisonTable data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <CostTable data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
      <SocialProofPopup data-id="element-18" />
    </div>;
}